/**
 * Retrieves the relevant pid value
 * @param {jquery} $el - DOM container for a given add to cart button
 * @return {string} - value to be used when adding product to cart
 */
 const getPidValue = ($el) => {
    let pid;

    if ($('.quickview-modal').hasClass('tingle-modal--visible') && !$('.product-set').length) {
        pid = $('.quickview-modal').find('.product-quickview').data('pid');
    } else if ($('.product-set-detail').length || $('.product-set').length) {
        pid = $($el).closest('.product-detail').find('.product-id').text();
    } else {
        pid = $('.product-detail:not(".bundle-item")').data('pid');
    }

    return pid;
};

export {
    getPidValue
};